import React from "react";
import {observer} from "mobx-react-lite";
import {Modal, ModalBody, ModalFooter} from "reactstrap";
import ButtonIcon from "../../atoms/button/buttonIcon";
import {useTranslation} from "react-i18next";
import {IconSource} from "../../../shared/enums/iconSource";
import "./updatesQuietHourNotificationModal.sass";
import Banner from "../../atoms/banner/banner";
import ModalDetailHeader from "../../molecules/modalDetailHeader/modalDetailHeader";
import Flex from "../../atoms/common/flex";
import {useStores} from "../../../stores/useStores";
import classNames from "classnames";
import CheckBox from "../../atoms/checkBox/checkBox";

export interface IUpdatesQuietHourNotificationModalProps {
  isOpen: boolean;
  toggle: () => void;
  onPublishBtnClicked: () => void;
  isSaving: boolean;
}

const UpdatesQuietHourNotificationModal: React.FC<
  IUpdatesQuietHourNotificationModalProps
> = ({isOpen, toggle, onPublishBtnClicked, isSaving}) => {
  const {t} = useTranslation(["translation", "notice"]);
  const {
    uiStore: {modalStore},
    domainStore: {noticesDomainStore}
  } = useStores();

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      data-testid="updatesQuietHourNotificationModalTest"
      modalClassName="updates-quiet-hour-notification-modal"
      centered
    >
      <ModalDetailHeader isLoading={false} toggle={toggle}>
        <div className="header-container">
          <Banner
            text={t("notice:labels.noticeQuietHoursDialogTitle")}
            icon={IconSource.error}
          />
        </div>
      </ModalDetailHeader>
      <ModalBody>
        <>
          <div className="notification-message">
            {t("notice:labels.noticeQuietHoursDialogText")}
          </div>

          <div className="checkbox-container">{t("notice:checkbox.title")}</div>
          <div>
            <CheckBox
              testId="checkBoxTest"
              value={
                noticesDomainStore.editableNotice.ignoreQuietHours?.value ??
                false
              }
              onValueChange={(isChecked) =>
                noticesDomainStore.editableNotice.ignoreQuietHours?.setBoolean(
                  isChecked
                )
              }
              clickable={true}
              label={t("notice:checkbox.label")}
              helpText={t("notice:checkbox.helpText")}
            />
          </div>
        </>
      </ModalBody>
      <ModalFooter
        tag={Flex}
        justify={modalStore.footerButtonAlignment}
        className={classNames("modal-footer")}
      >
        <div className="modal-buttons"></div>
        <ButtonIcon
          type={"primary"}
          onClick={() => onPublishBtnClicked()}
          isDisabled={isSaving}
        >
          {t("translation:actions.publish")}
        </ButtonIcon>
      </ModalFooter>
    </Modal>
  );
};

export default observer(UpdatesQuietHourNotificationModal);
